import { render, staticRenderFns } from "./AssessmentsShow.vue?vue&type=template&id=ca84d288&"
import script from "./AssessmentsShow.vue?vue&type=script&lang=js&"
export * from "./AssessmentsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports